import { forwardRef } from 'react';

import { Faq } from 'Blocks/Faq';

import { faq } from 'assets/content/landingPages/stylingGel';

type StylingGelFAQProps = {
  dataTestId: string;
};

export const StylingGelFAQ = forwardRef<HTMLElement, StylingGelFAQProps>(({ dataTestId }, ref) => {
  const { headline: faqHeadline, questions: faqQuestions } = faq;

  return (
    <Faq
      ref={ref}
      backgroundColor="veryLightPink"
      dataFrom="faq-block"
      dataTestId={dataTestId}
      questions={faqQuestions}
      title={faqHeadline}
    />
  );
});

StylingGelFAQ.displayName = 'StylingGelFAQ';
